module.exports = __webpack_public_path__ + "static/img/lookVedioBG.b6fa315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lookVedioBG.png
// module id = X2hM
// module chunks = 4